import IconsColor from "./IconsColor";

interface MenuItem {
    name: string;
    icon: React.ReactNode;
    selectedIcon?: React.ReactNode;
    path: string;
    subItems?: MenuItem[];
}

// Helper function to format numbers with only thousand separators (no currency symbol)
export const formatWithThousandSeparator = (value: string | number): string => {
    if (!value) return '';
    const number = Number(String(value).replaceAll(',', ''));
    if (Number.isNaN(number)) return String(value);
    return new Intl.NumberFormat('en-US', {
        useGrouping: true,
        maximumFractionDigits: 2
    }).format(number);
};


export const cardKeys = {
    issueAge: "Issue Age",
    withdrawalStartAge: "Withdrawal Start Age",
    lifeExpectancy: "Life Expectancy",
    premium: "Premium",
    premiumBonus: "Premium Bonus",
    portfolioAmountStartOfYear: "Portfolio Amount Start of the Year",
    intrestEarnedDuringTheYear: "Interest Earned During the Year",
    portfolioAmountEndOfYear: "Portfolio Amount End of the Year",
    deathBenefitEndOfYear: "Death Benefit End of the Year",
    iraPortfolioStartOfTheYear: "IRA portfolio start of the year",
    iraPortfolioEndOfTheYear: "IRA portfolio end of the year",
    rothPortfolioStartofTheYear: "Roth Portfolio Start of the Year",
    rothPortfolioEndofTheYear: "Roth Portfolio End of the Year",
    taxRatesLifetimeWithDrawals: "Tax Rate (lifetime withdrawals)",
    accountValue: "Account Value",
    annualIncomeTaxPaid: "Annual Income Tax Paid",
    totalIncomeTaxPaid: "Total Income Tax Paid",
    conversationPeriod: "Conversation Period",
    taxRatePartialRothIRA: 'Tax Rate (partial Roth IRA)',
    accountValueForIRA: 'Account Value for IRA',
    accountValueForRoth: 'Account Value for Roth',
    annualWithdrawalRate: "Annual Withdrawal Rate (%)",
    annualGrossWithDrawal: "Annual Gross Withdrawal",
    annualNetWithDrawal: "Annual Net Withdrawal",
    totalWithDrawals: "Total Withdrawals",
    totalGrossWithDrawals: "Total Gross Withdrawals",
    totalNetWithDrawals: "Total Net Withdrawals",
    annualNetWithdrawalwopPercentage: 'Annual Net Withdrawal',
}

export type FormatType = 'currency' | 'percentage' | 'value';

export const formatCurrency = (value: number | string | undefined | null, type: FormatType = 'currency'): string => {
    if (value === undefined || value === null || value === '') return "$0";

    const cleanValue = typeof value === 'string' ? value.replaceAll(',', '') : value;
    const num = Number(cleanValue);

    if (Number.isNaN(num)) return "$0";

    switch (type) {
        case 'percentage':
            return `${num.toFixed(2)}%`;

        case 'value':
            return `$${Math.round(num).toLocaleString()}`;

        case 'currency':
        default:
            return `$${num.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}`;
    }
};

export function convertDateToUSFormat(dateStr: string) {
    const date = new Date(dateStr);
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
}

export const getMenuItems = (userRole: string): MenuItem[] => {
    const baseMenuItems: MenuItem[] = [
        {
            name: 'Profiles',
            icon: <IconsColor iconName={'profileLogo'} />,
            selectedIcon: <IconsColor iconName={'profileLogo'} color="#04385D" />,
            path: `/profile`,
        },
        {
            name: 'Inflation Calculator',
            icon: <IconsColor iconName={'inflationCalcIcon'} />,
            selectedIcon: <IconsColor iconName={'inflationCalcIcon'} color="#04385D" />,
            path: `/inflationcalculator`,
        },
        {
            name: 'Spend Down Calc',
            icon: <IconsColor iconName={'spendDownCalcIcon'} />,
            selectedIcon: <IconsColor iconName={'spendDownCalcIcon'} color="#04385D" />,
            path: `/spendDownCalc`,
        },
        {
            name: 'Training',
            icon: <IconsColor iconName={'trainingLogo'} />,
            selectedIcon: <IconsColor iconName={'trainingLogo'} color="#04385D" />,
            path: '/training',
        },
    ];

    if (userRole?.toLowerCase() === 'admin') {
        baseMenuItems.unshift(
            {
                name: 'Dashboard',
                icon: <IconsColor iconName={'homeLogo'} />,
                selectedIcon: <IconsColor iconName={'homeLogo'} color="#04385D" />,
                path: '/dashboard',
            },
            {
                name: 'Agents',
                icon: <IconsColor iconName={'agentsLogo'} />,
                selectedIcon: <IconsColor iconName={'agentsLogo'} color="#04385D" />,
                path: '/agent',
            },
            {
                name: 'Pending Requests',
                icon: <IconsColor iconName={'pendingRequestsIcon'} />,
                selectedIcon: <IconsColor iconName={'pendingRequestsIcon'} color="#04385D" />,
                path: '/pending-requests',
            }
        );
    } else if (userRole?.toLowerCase() === 'super admin') {
        return [
            {
                name: 'Dashboard',
                icon: <IconsColor iconName={'homeLogo'} />,
                selectedIcon: <IconsColor iconName={'homeLogo'} color="#04385D" />,
                path: '/super-admin-dashboard',
            },
        ];
    }

    return baseMenuItems;
};